import { formatNumber, parseNumber } from 'libphonenumber-js'
import Environment from '../../common/environment';
import stgConfig from "../../../../config";
import * as $ from "jquery";

class SmsForm {
  componentRoot: JQuery<HTMLElement>;
  params: any;
  environment: string;
  path: string;
  endpoint: any;
  form: JQuery<HTMLElement>;
  selectInput: JQuery<HTMLElement>;
  phoneNumberInput: JQuery<HTMLElement>;
  successBlock: JQuery<HTMLElement>;
  error: JQuery<HTMLElement>;
  countryCode: string;
  phoneNumber: string;
  errorMessage: string;
  
  constructor(componentRoot: HTMLElement, params: any) {
    this.componentRoot = $(componentRoot);
    this.params = params;
    this.environment = Environment.getEnvironment();
    this.path = '/texter/process';

    const DEV_ENV = Environment.dev();
    const STAGING_ENV = Environment.staging();
    const PRODUCTION_ENV = Environment.production();

    const BXP_EXPRESS_ENDPOINT = {};
    BXP_EXPRESS_ENDPOINT[PRODUCTION_ENV] = 'https://www.atlassian.com/endpoint';
    BXP_EXPRESS_ENDPOINT[STAGING_ENV]    = `${window.location.hostname.indexOf('qa-wac') > -1 ? 'https://qa-wac.internal.atlassian.com' : stgConfig.stgWacInternalUrl}/endpoint`;
    BXP_EXPRESS_ENDPOINT[DEV_ENV]        = BXP_EXPRESS_ENDPOINT[STAGING_ENV];

    this.endpoint = BXP_EXPRESS_ENDPOINT[this.environment] + this.path;

    this.form = $(`#${this.params.formId}`);
    this.selectInput = $(`#${this.params.selectInputId}`);
    this.phoneNumberInput = $(`#${this.params.phoneNumberInputId}`);
    this.successBlock = $(`#${this.params.successId}`);
    this.error = $('.error', this.componentRoot);
    this.countryCode = '';
    this.phoneNumber = ''
    this.errorMessage = '';
    this.bindEvents();
  }

  bindEvents () {
    this.selectInput.on('change', event => {
      this.countryCode = event.target.value;
      this.phoneNumberInput.val(this.formattedPhoneNumber());
    });
    this.phoneNumberInput.on('input', event => {
      this.phoneNumber = event.target.value;
      event.target.value = this.formattedPhoneNumber();
    });
    this.form.on('submit', event => {
      event.preventDefault();
      if (this.hasError()) {
        this.setError(this.errorMessage);
      } else {
        this.sendSms();
      }
    });
  }

  formattedPhoneNumber () {
    let self = this;
    return formatNumber({country: self.countryCode, phone: self.phoneNumber}, 'National');
  }

  hasError () {
    let hasError = true;
    let phoneNumberInfo = parseNumber(this.phoneNumber, this.countryCode, { extended: true });
    if (this.countryCode === '') {
      this.errorMessage = this.params.countryCodeError;
    } else if (!phoneNumberInfo.valid) {
      this.errorMessage = this.params.phoneNumberError;
    } else {
      hasError = false;
    }
    return hasError;
  }

  setError (message) {
    this.error.text(message);
  }

  hideFormShowSucess () {
    this.form.addClass('hide-all');
    this.successBlock.removeClass('hide-all');
  }

  sendSms () {
    let data = {
      "product": this.params.product,
      "country": this.countryCode,
      "phoneNumber": this.phoneNumber
    };
    fetch(this.endpoint, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(result => {
      if (!result.success) {
        throw result;
      }
      this.hideFormShowSucess();
    })
    .catch(error => {
      let message = this.params.genericError;
      if (error.error) {
        // this comes back from server
        message = error.error;
      }
      this.setError(message);
    });
  }
}

export default SmsForm;
